<template>
    <div class="main-container">
        <ArticleCard v-for="(slug, index) in slugs"
                     v-bind:class="{removed: slugs.length - currentIndex <= index, next: slugs.length - currentIndex - 1 === index}"
                     :key="slug"
                     :slug="slug"
                     :articleData="articles[slug]"
                     :id="index"/>
        <div class="buttons">
            <div class="down" v-bind:class="{hidden: slugs.length - currentIndex - 1 === 0}" @click="nextCard">&lt;&lt;- Older</div>
            <div class="button-spacer" v-bind:class="{hidden: currentIndex === 0 || slugs.length - currentIndex - 1 === 0}"></div>
            <div class="up" v-bind:class="{hidden: currentIndex === 0}" @click="prevCard">Newer ->></div>
        </div>
    </div>
</template>

<script>
    import ArticleCard from './ArticleCard';
    import firebaseApp from '../firebaseInit';

    let db = firebaseApp.db;

    export default {
        name: 'ArticleList',
        components: {
            ArticleCard
        },
        data: function() {
            return {
                currentIndex: 0,
                slugs: [],
                articles: {}
            }
        },
        watch: {
            '$route': 'fetchArticles'
        },
        created: function() {
            if (!isNaN(Number(this.$route.params.index))) {
                this.currentIndex = Number(this.$route.params.index);
            }
            this.fetchArticles();
        },
        methods: {
            nextCard: function() {
                this.currentIndex = Math.min(this.currentIndex + 1, this.slugs.length - 1);
                history.pushState({}, '', '/#/' + this.currentIndex);
            },
            prevCard: function() {
                this.currentIndex = Math.max(this.currentIndex - 1, 0);
                history.pushState({}, '', '/#/' + this.currentIndex);
            },
            fetchArticles() {
                db.collection('articles').orderBy("timestamp", "asc").get().then(
                    (querySnapshot) => {
                        querySnapshot.forEach((doc) => {
                            this.slugs.push(doc.id);
                            this.articles[doc.id] = doc.data();
                        });
                        document.getElementsByClassName('main-container')[0].classList.add('visible');
                    }
                );
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .main-container {
        opacity: 0;
        transition: 0.3s;

        display: flex;
        justify-content: center;
        align-items: center;

        perspective: 1000px;
        transform-style: preserve-3d;

        overflow: hidden;
        flex-grow: 1;
    }

    .visible {
        opacity: 1;
    }

    .buttons {
        color: white;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        transform: translate(35vw) rotate(90deg);
        user-select: none;
    }

    .button-spacer {
        width: 50px;
    }

    .up {
        transition: 0.1s;
        cursor: pointer;
        padding: 5px;
        border-radius: 20px;
    }

    .down {
        transition: 0.1s;
        cursor: pointer;
        padding: 5px;
        border-radius: 20px;
    }

    .hidden {
        opacity: 0;
        cursor: default;
    }
</style>
